import * as caretakerDetailsManager from '$domain/model/caretaker/caretakerDetails/caretakerDetails.manager'

export const getCaretakerDetails = caretakerId => caretakerDetailsManager.getCaretakerDetails(caretakerId)



// WEBPACK FOOTER //
// ./src/services/caretaker/caretakerDetails/caretakerDetails.service.ts